import { liteClient } from 'algoliasearch/lite';
import instantsearch from 'instantsearch.js';
import { opts } from '../opts.js';
import { router } from './routing.js';

export const searchClient = liteClient(
	'7ETSG482D3',
	'82b0c196802d3ae88c0b5b116e73e11b'
);

export const search = instantsearch({
	searchClient,
	indexName: opts.base.indexName,
	routing: {
		router,
	},
	future: {
		preserveSharedStateOnUnmount: true,
		// persistHierarchicalRootCount: boolean,
	}
});

